
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/toplists",
      function () {
        return require("private-next-pages/hotels/toplists.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotels/toplists"])
      });
    }
  